import { IconButton, Tooltip } from '@mui/material';
import { useState } from 'react';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';
import { toast } from 'react-toastify';
import { theme } from '@store';

const DISABLED_DURATION_MS = 2000;

interface IClipboardButtonProps {
  textToCopy: string;
  size?: number;
  tooltipMessage?: string;
}

export const ClipboardButton = ({
  textToCopy,
  size = 24,
  tooltipMessage = 'Copy',
}: IClipboardButtonProps) => {
  const [disabled, setDisabled] = useState(false);

  const handleCopyToClipboard = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    navigator.clipboard.writeText(textToCopy);

    toast.success('Copied to clipboard', {
      icon: () => <CheckIcon sx={{ color: 'white', fontSize: '20px' }} />,
      style: { alignItems: 'center' },
    });

    setDisabled(true);
    setTimeout(() => setDisabled(false), DISABLED_DURATION_MS);
  };

  if (textToCopy == null || textToCopy === '') return null;

  return (
    <Tooltip title={tooltipMessage} placement='top'>
      <span title=''>
        <IconButton
          disabled={disabled}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            mr: '0.5rem',
            borderRadius: '8px',
            position: 'relative',
            p: 0,
          }}
          onClick={handleCopyToClipboard}
        >
          {disabled ? (
            <CheckIcon
              sx={{
                color: theme.palette.success.main,
                fontSize: `${size}px`,
              }}
            />
          ) : (
            <ContentCopyIcon
              sx={{
                color: theme.palette.semiBlack.main,
                fontSize: `${size}px`,
              }}
            />
          )}
        </IconButton>
      </span>
    </Tooltip>
  );
};
